<div class="ham-wrap" (click)="closeNewHamburger($event)" [attr.data-locale]="currentLocale">
  <div class="ham-area">
    <div class="ham-body">

      <div class="menu" *ngIf="uhfSettings.linkMenuSection">
        <ul *ngIf="localeTexts.length">

          <li [ngClass]="{'active' : i == 0}" *ngFor="let item of localeTexts[0].navigation[0].content; let i = index;" (click)="openSecNav('My bookings', i)">
            <i class="material-icons" aria-hidden="true">{{navMenuIcons[i]}}</i>
            <span>{{item.text ? item.text : ''}}</span>
          </li>

        </ul>
      </div>

      <!-- Link menu and any one setting present -->
      <hr aria-hidden="true" class="hr-color hr-adjust 1" *ngIf="uhfSettings.linkMenuSection && (uhfSettings.languageSection || uhfSettings.currencySection)">

      <!-- Link menu, footer present and no settings present -->
      <hr aria-hidden="true" class="hr-color hr-adjust 2" *ngIf="uhfSettings.linkMenuSection && uhfSettings.footerSection && (!uhfSettings.languageSection && !uhfSettings.currencySection)">

      <div class="setting" *ngIf="localeTexts.length && (uhfSettings.languageSection || uhfSettings.currencySection)">
        <ul>
          <li class="title">{{localeTexts[3].main.settings}}</li>
          <li (click)="openSecNav('lang')" *ngIf="uhfSettings.languageSection">
            <i class="material-icons">language</i>
            <span>{{currentLang}}</span>
            <i class="material-icons r-arrow">chevron_right</i>
          </li>
          <li (click)="openSecNav('curr')" *ngIf="uhfSettings.currencySection">
            <i class="material-icons">attach_money</i>
            <span>
              <b>{{currCode}}</b>
            </span>
            <span style="padding-left: 8px;">{{currentCurr}}</span>
            <i class="material-icons r-arrow">chevron_right</i>
          </li>
        </ul>
      </div>

      <!-- Any one setting present -->
      <hr class="hr-color hr-adjust 3" *ngIf="uhfSettings.languageSection || uhfSettings.currencySection">

      <!-- Link menu, footer present and no setting present -->
      <!-- <hr class="hr-color hr-adjust 4" *ngIf="uhfSettings.linkMenuSection && uhfSettings.footerSection && (!uhfSettings.languageSection && !uhfSettings.currencySection)"> -->

      <div class="ham-footer" *ngIf="uhfSettings.footerSection">
        <aa-footer [isMobile]="true"></aa-footer>
      </div>

    </div>
  </div>

  <div class="closeHamMark cl">
    <div class="x cl">
      <i class="material-icons cl">clear</i>
    </div>
    <div class="person cl">
      <i class="material-icons cl">person</i>
    </div>
  </div>

</div>

<aa-secondarynav [contentToShow]="contentToShow"></aa-secondarynav>
